import React from "react";
import Toasts from "../notificacion/Toasts";
import {StateContext} from "../context/StateProvider";
import AsignaService from "../../services/asigna.service";
import HandleExceptions from "../../exceptions/HandleExceptions";
import StickerService from "../../services/sticker.service";
import Utils from "../../utils/Utils";


class PrintStickerAsigna extends React.Component {

    static contextType = StateContext;

    constructor(props) {
        super(props);
        this.iframRef = React.createRef();
        this.state = {
            url: null,
        };
    }

    async printSticker(sticker, delivery) {

        const {state, updateState} = this.context;

        try {
            if (sticker.cp !== '' && sticker.address !== '' && sticker.name !== '') {

                if (Utils.isFullEmpty(sticker.expedicionAsigna)) {
                    const resultRegisterDelivery = await AsignaService.registerDelivery(sticker, delivery);
                    if (resultRegisterDelivery.data) {
                        sticker.expedicionAsigna = resultRegisterDelivery.data.exp;
                        sticker.zona = resultRegisterDelivery.data.zona;
                        state.toasts.push(Toasts.generateToast('Generada etiqueta', 'success'));
                        // Guardar en servidor exp en etiqueta
                        await StickerService.registerSticker(sticker).then(
                            async () => {
                                state.toasts.push(Toasts.generateToast('Expedición a etiqueta', 'success'));
                            }
                        );
                    } else {
                        HandleExceptions.throwException("Error generando etiqueta:" + resultRegisterDelivery.message);
                    }
                }

            } else {
                HandleExceptions.throwException("Se necesita rellenar todos los campos de la dirección para generar etiqueta");
            }

            updateState({toasts: state.toasts})

        } catch (error) {
            this.setState({url: null});
            updateState({toasts: [...state.toasts, Toasts.generateToast(error.message, 'error')]})
        }
    }

    handleIframeLoad() {
        if (this.state.url !== null) {
            const iframeWindow = this.iframRef.current.contentWindow;
            iframeWindow.print();
        }
    };

    render() {
        const {url} = this.state;
        return (
            <iframe className='hidden' ref={this.iframRef} src={url}/>
        );
    }
}

export default PrintStickerAsigna;